import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { convertFromSeconds } from '../../core/utils/functions';
import GridView from '../elements/GridView';
import * as videoActions from '../../core/video/videoActions';
import AddressFetcher from '../elements/AddressFetcher';
import { Time } from '@carbon/icons-react';
import { getPaginationTotal } from '../elements/GridView/GridViewBase/Pagination';

function VideoHistory({
    videos,
    pagination,
    handleTableChange,
    handlePaginationChange,
    sortableColumns,
}) {
    const columns = (videos && videos.map((v) => ({
        id: v.id,
        date: v.start_time && moment(v.start_time).format('DD/MM/YYYY'),
        time: v.start_time && v.start_time.substring(11),
        location: (
            <AddressFetcher
                key={v.id}
                lat={v.latitude}
                lng={v.longitude}
            />
        ),
        duration: (
            <div className="d-flex align-center">
                <Time />
                <span className="ml-1">{convertFromSeconds(v.duration)} </span>
            </div>
        ),
        actions: (
            <Link
                to={`/video/view/${v.id}`}
                className="btn-actions"
            >
                View
            </Link>
        ),
    }))) || [];

    return (
        <GridView
            data={columns}
            onChange={handleTableChange}
            sortableColumns={sortableColumns}
            hiddenColumns={['id']}
            pagination={{
                total: parseInt(pagination.totalRecords, 10),
                pageSize: parseInt(pagination.perPageCount, 10),
                showSizeChanger: false,
                onChange: handlePaginationChange,
                showTotal: getPaginationTotal,
            }}
        />
    );
}

VideoHistory.defaultProps = {
    loading: false,
    pagination: { page: 1, totalRecords: 16, perPageCount: 16 },
    handleTableChange: () => null,
    handlePaginationChange: () => null,
    sortableColumns: [],
};

VideoHistory.propTypes = {
    loading: PropTypes.bool,
    videos: PropTypes.array.isRequired,
    pagination: PropTypes.object,
    handleTableChange: PropTypes.func,
    handlePaginationChange: PropTypes.func,
    sortableColumns: PropTypes.arrayOf(PropTypes.string),
    actions: PropTypes.object.isRequired,
};

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            {
                ...videoActions,
            },
            dispatch,
        ),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(VideoHistory);
